import { useRouter } from 'next/router'
import { useBogo } from '@mc/bogo-utils'
import { QUIZ_QUERY_PARAMS } from '@mc/find-my-classes'
import { paths } from '@mc/paths'
import { usePromotion } from '@mc/promo-utils'
import { appendQRISCQueryParam } from 'experiments/pen-5713_v1_qr_innovative_swing'

export const useQRCTAHref = () => {
  const router = useRouter()

  const { isPromotionOn: shouldGoToPromoPage } = usePromotion()
  const { isBogoOfferEligible: shouldGoToBogoPage } = useBogo()

  const isQuizResultsPage = router.pathname.includes(
    paths.classRecommendationsResults,
  )

  if (!isQuizResultsPage) {
    return undefined
  }

  // if the param SKIP_Q1 is set, it means the user comes from the home hero quiz cta
  // so we need to take them to the /promotion page
  const fromHeroQuiz = router.query[QUIZ_QUERY_PARAMS.SKIP_Q1] === 't'
  const goToPromotion = shouldGoToPromoPage && fromHeroQuiz

  const checkoutWithQrisc = appendQRISCQueryParam(paths.checkout)

  if (shouldGoToBogoPage) return paths.bogo
  if (goToPromotion) return paths.promotionRedirect(checkoutWithQrisc)
  return checkoutWithQrisc
}
